import { ATTRS, TAGS } from '../constants';
import { Entity } from '../types';
import { lineStringABLine2GeoJSON, polygonToLineStringXML } from '../geometry';

export class GuidancePatternEntity implements Entity {
  public static fromXML(xml) {
    const attrs = xml._attributes;
    const isoId = attrs[ATTRS.GuidancePattern.GuidancePatternId];
    // const id = matchIDs[isoId] ? matchIDs[isoId].id : null

    const lineStrings = (xml[TAGS.LineString] || []).map((xml) => lineStringABLine2GeoJSON(xml));

    return {
      entity: new GuidancePatternEntity(
        isoId,
        attrs[ATTRS.GuidancePattern.GuidancePatternDesignator],
        attrs[ATTRS.GuidancePattern.GuidancePatternType],
        attrs[ATTRS.GuidancePattern.GuidancePatternOptions],
        attrs[ATTRS.GuidancePattern.GuidancePatternPropagationDirection],
        attrs[ATTRS.GuidancePattern.GuidancePatternExtension],
        attrs[ATTRS.GuidancePattern.GuidancePatternHeading],
        attrs[ATTRS.GuidancePattern.GuidancePatternRadius],
        attrs[ATTRS.GuidancePattern.GuidancePatternGNSSMethod],
        attrs[ATTRS.GuidancePattern.GuidancePatternHorizontalAccuracy],
        attrs[ATTRS.GuidancePattern.GuidancePatternVerticalAccuracy],
        attrs[ATTRS.GuidancePattern.BaseStationIdRef],
        attrs[ATTRS.GuidancePattern.OriginalSRID],
        attrs[ATTRS.GuidancePattern.NumberOfSwathsLeft],
        attrs[ATTRS.GuidancePattern.NumberOfSwathsRight],
        lineStrings
      ),
      isoId,
    };
  }
  public type = TAGS.GuidancePattern;
  public id: string;

  constructor(
    id: string,
    public designator: string,
    public patternType?: string,
    private options?: string,
    private propagationDirection?: string,
    private extension?: string,
    private heading?: number,
    private radius?: number,
    private GNSSMethod?: string,
    private horizontalAccuracy?: number,
    private verticalAccuracy?: number,
    private baseStationIdRef?: string,
    private originalSRID?: string,
    private numberOfSwathsLeft?: number,
    private numberOfSwathsRight?: number,
    private lineString?: any
  ) {
    this.id = id;
  }

  public toXML() {
    return {
      _attributes: {
        [ATTRS.GuidancePattern.GuidancePatternId]: this.id,
        [ATTRS.GuidancePattern.GuidancePatternDesignator]: this.designator,
        [ATTRS.GuidancePattern.GuidancePatternType]: this.patternType,
        [ATTRS.GuidancePattern.GuidancePatternOptions]: this.options,
        [ATTRS.GuidancePattern.GuidancePatternPropagationDirection]: this.propagationDirection,
        [ATTRS.GuidancePattern.GuidancePatternExtension]: this.extension,
        [ATTRS.GuidancePattern.GuidancePatternHeading]: this.heading,
        [ATTRS.GuidancePattern.GuidancePatternRadius]: this.radius,
        [ATTRS.GuidancePattern.GuidancePatternGNSSMethod]: this.GNSSMethod,
        [ATTRS.GuidancePattern.GuidancePatternHorizontalAccuracy]: this.horizontalAccuracy,
        [ATTRS.GuidancePattern.GuidancePatternVerticalAccuracy]: this.verticalAccuracy,
        [ATTRS.GuidancePattern.BaseStationIdRef]: this.baseStationIdRef,
        [ATTRS.GuidancePattern.OriginalSRID]: this.originalSRID,
        [ATTRS.GuidancePattern.NumberOfSwathsLeft]: this.numberOfSwathsLeft,
        [ATTRS.GuidancePattern.NumberOfSwathsRight]: this.numberOfSwathsRight,
      },
      [TAGS.LineString]: polygonToLineStringXML(this.lineString),
    };
  }
}
